import PropTypes from 'prop-types';
import React from 'react';

import TariffInfo from './TariffInfo';

function TariffDetails(props) {
  return (
    <div className={'tariff-details'}>
      <TariffInfo data={props.details.data} />
      <TariffInfo data={props.details.minutes} />
      <TariffInfo data={props.details.texts} />
    </div>
  );
}

TariffDetails.propTypes = {
  details: PropTypes.shape({
    data: PropTypes.objectOf(PropTypes.string).isRequired,
    minutes: PropTypes.objectOf(PropTypes.string).isRequired,
    texts: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired
};

TariffDetails.displayName = 'TariffDetails';

export default TariffDetails;
